<div class="channel-engine-panel">

  <div class="panel-intro">
    <p class="intro-text">
      Legt fest, welche Engine einen Sender live transkribiert. Steht ein Sender auf
      <strong>Voxtral</strong>, wird jede ab dann als KIUT markierte Sendung dieses Senders
      automatisch für Voxtral eingeplant — sonst übernimmt Whisper.
    </p>
    <p class="intro-note">
      <cds-icon shape="info-circle"></cds-icon>
      Eine Umstellung greift sofort auf die noch nicht begonnenen Sendungen dieses Senders
      (heutiger Rest und morgen), die bereits KIUT und Live sind — inklusive FAB-Ziel.
      Laufende Sessions, ausdrücklich abgewählte Sendungen und solche, die über PCMS/VOD
      transkribiert werden, bleiben unangetastet. Einzeln lässt sich weiterhin alles im
      Sendungs-Detail ändern.
    </p>
  </div>

  <div class="alert alert-success" role="alert" *ngIf="lastRollout as r">
    <div class="alert-items">
      <div class="alert-item static">
        <cds-icon shape="check-circle" class="alert-icon"></cds-icon>
        <span class="alert-text">
          {{ r.channel }} auf {{ r.engine === 'voxtral' ? 'Voxtral' : 'Whisper' }} umgestellt —
          {{ r.scanned }} anstehende Sendung(en) geprüft:
          {{ r.armed }} eingeplant, {{ r.fabBackfilled }} FAB-Ziel ergänzt, {{ r.reverted }} zurückgesetzt, {{ r.skipped }} unverändert.
        </span>
      </div>
    </div>
  </div>

  <div class="panel-toolbar">
    <span class="summary" *ngIf="loaded">
      {{ voxtralCount }} von {{ rows.length }} Sendern auf Voxtral
    </span>
    <button type="button" class="btn btn-sm btn-link" (click)="load()" [disabled]="loading">
      <cds-icon shape="refresh"></cds-icon> Neu laden
    </button>
  </div>

  <div class="alert alert-danger" role="alert" *ngIf="error">
    <div class="alert-items">
      <div class="alert-item static">
        <cds-icon shape="exclamation-circle" class="alert-icon"></cds-icon>
        <span class="alert-text">{{ error }}</span>
      </div>
    </div>
  </div>

  <div class="loading-row" *ngIf="loading && !loaded">
    <clr-spinner clrSmall clrInline></clr-spinner> Sender werden geladen…
  </div>

  <table class="table table-compact channel-table" *ngIf="loaded">
    <thead>
      <tr>
        <th class="left">Sender</th>
        <th class="left">Primäre Live-Transkription</th>
        <th class="left">Quelle</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows">
        <td class="left channel-cell">
          <img class="channel-icon" [src]="iconFor(row.channel)" [alt]="row.channel" />
          <span class="channel-name">{{ row.channel }}</span>
        </td>
        <td class="left">
          <fieldset [disableUnlessPermission]="'control-infrastructure'" class="rbac-fieldset">
            <select class="clr-select engine-select"
                    [ngModel]="row.engine"
                    (ngModelChange)="onEngineChange(row, $event)"
                    [disabled]="row.saving"
                    [attr.aria-label]="'Primäre Live-Transkription für ' + row.channel">
              <option value="whisper">Whisper</option>
              <option value="voxtral">Voxtral</option>
            </select>
          </fieldset>
          <clr-spinner clrSmall clrInline *ngIf="row.saving"></clr-spinner>
        </td>
        <td class="left">
          <span class="label label-light" *ngIf="!row.isExplicit">Standard</span>
          <span class="label label-info" *ngIf="row.isExplicit">gesetzt</span>
        </td>
      </tr>
    </tbody>
  </table>

</div>
